import { render, staticRenderFns } from "./RowBlockWritingOffCommissionTestDgo.vue?vue&type=template&id=4d4b2fbf&"
import script from "./RowBlockWritingOffCommissionTestDgo.vue?vue&type=script&lang=js&"
export * from "./RowBlockWritingOffCommissionTestDgo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports